import { render, staticRenderFns } from "./BannerPosition.vue?vue&type=template&id=af49fc98&scoped=true"
import script from "./BannerPosition.vue?vue&type=script&lang=js"
export * from "./BannerPosition.vue?vue&type=script&lang=js"
import style0 from "./BannerPosition.vue?vue&type=style&index=0&id=af49fc98&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af49fc98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af49fc98')) {
      api.createRecord('af49fc98', component.options)
    } else {
      api.reload('af49fc98', component.options)
    }
    module.hot.accept("./BannerPosition.vue?vue&type=template&id=af49fc98&scoped=true", function () {
      api.rerender('af49fc98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/components/groupBanner/BannerPosition.vue"
export default component.exports